import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
import { ActiveDealersDashboardComponent } from './active-dealers-dashboard.component';
import { ClientFilesPostageTrackingReportComponent } from './client-files-postage-tracking-report.component'
const routes: Routes = [
   
    {
        path: 'home',
        component: DashboardComponent
       
    },
    {
        path: 'activeDealers',
        component: ActiveDealersDashboardComponent
       
    },
    {
        path: 'clientfilepostage',
        component: ClientFilesPostageTrackingReportComponent
       
    }

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DashboardRoutingModule { }
